<template>
<div>

        <!-- :actions="['edit','more','delete']" -->


    <el-crud :baseUrl="'/functionalareas'" 
        name="functionalareas"
        v-model="resource"
        :actions="['edit','delete']"
        :config="crudConfig"
        :filters="filters"
        ref="crud">


        <template slot="crudFiltersDescription">
            <div v-if="filters.shift_id != null && filters.shift_id.length">Turno: <strong>{{shift_name}}</strong></div>
            <div v-if="filters.device_id != null && filters.device_id.length">Dispositivo: <strong>{{device_name}}</strong></div>
            <div v-if="filters.filter">Área: <strong>{{filters.filter}}</strong></div>
            <div v-if="!areFilters"><strong>Datos sin filtrar</strong></div>
        </template>

        <template slot="crudFiltersForm">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Turno" label-width="120px" prop="functional_area_id">
                        <el-select multiple v-model="filters.shift_id" filterable placeholder="Seleccione">
                            <el-option label="Acceso a todas" :value="0"></el-option>
                            <el-option
                                v-for="item in shiftsOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Dispositivo" label-width="120px" prop="profile">
                        <el-select multiple v-model="filters.device_id" filterable placeholder="Seleccione">
                            <el-option
                                v-for="item in devices"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="Área" label-width="120px" prop="filter">
                        <el-input placeholder="Código o descripción" v-model="filters.filter" clearable></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>


        <template slot="table">
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <el-row :gutter="20">
                        <el-col :span="12"><div><strong>Turnos</strong></div>
                            <table class="details">
                                <tr v-for="item in scope.row.shifts" :key="'s'+item.id">
                                    <td><strong>{{item.pivot.description}}:&nbsp;</strong></td>
                                    <td>{{ item.company_id_number }} - {{item.description}}</td>
                                </tr>
                            </table>
                        </el-col>
                        <el-col :span="12"><div><strong>Dispositivos</strong></div>
                            <table class="details">
                                <tr v-for="item in scope.row.devices" :key="'d'+item.id">
                                    <td><strong>{{item.id}}:&nbsp;</strong></td>
                                    <td>{{ item.name }}</td>
                                </tr>
                            </table>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column
                prop="company_id_number"
                label="Cód."
                align="right"
                width="80">
            </el-table-column>
            <el-table-column
                prop="description"
                label="Área">
            </el-table-column>
            <el-table-column
                align="center"
                label="Aliment.">
                <template slot-scope="scope">
                    <el-tag size="mini">{{ scope.row.feed ? "SI" : "NO"}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="Turnos">
                <template slot-scope="scope">
                    <el-tag v-for="item in scope.row.shifts.slice(0, 3)" :key="scope.row.id+item.company_id_number" size="mini">{{item.company_id_number}}</el-tag>
                    <span v-if="scope.row.shifts.length > 3">...</span>
                </template>
            </el-table-column>
            <el-table-column
                label="Dispositivos">
                <template slot-scope="scope">
                    <el-tag v-for="item in scope.row.devices.slice(0, 3)" :key="scope.row.id+item.id" size="mini">{{item.name}}</el-tag>
                    <span v-if="scope.row.devices.length > 3">...</span>
                </template>
            </el-table-column>
            <el-table-column
                label="CeCos">
                <template slot-scope="scope">
                    <el-tag v-for="item in scope.row.cost_centers.slice(0, 3)" :key="scope.row.id+item.id" size="mini">{{item.company_id_number}}</el-tag>
                    <span v-if="scope.row.cost_centers.length > 3">...</span>
                </template>
            </el-table-column>
        </template>

        <template slot="form" slot-scope="scope">
            <el-form-item label="Código" label-width="120px" prop="company_id_number" :error="scope.errors.company_id_number">
                <el-input v-model="resource.company_id_number" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Nombre" label-width="120px" prop="description" :error="scope.errors.description">
                <el-input v-model="resource.description" auto-complete="off" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="Alimentación" label-width="120px" prop="feed" :error="scope.errors.feed">
                <el-switch v-model="resource.feed.value"></el-switch>
            </el-form-item>
            <el-form-item label="Turnos" label-width="120px" :error="scope.errors.shifts">
                <el-repetitive-field v-model="resource.shifts.value" :buttonText="'Turno'" :default="{shift_id:null,description:null}">
                    <template slot-scope="props">
                        <el-col :xs="24" :sm="14">
                            <el-form-item :prop="'shift_'+props.item.shift_id">
                                <el-select v-model="props.item.shift_id" filterable placeholder="Seleccione" size="mini">
                                    <el-option
                                        v-for="item in shiftsOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="10">
                            <el-form-item :prop="'shift_desc_'+props.item.shift_id">
                                <el-input v-model="props.item.description" placeholder="Nombre (Ej: Mañana, Tarde, etc.)" size="mini"></el-input>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-repetitive-field>
            </el-form-item>
            <el-form-item label="Dispositivos" label-width="120px" :error="scope.errors.devices">
                <el-repetitive-field v-model="resource.devices.value" :buttonText="'Dispositivo'" :default="{device_id:null,description:null}">
                    <template slot-scope="props">
                        <el-col :xs="24" :sm="14">
                            <el-form-item :prop="'device_'+props.item.device_id">
                                <el-select v-model="props.item.device_id" filterable placeholder="Seleccione" size="mini">
                                    <el-option
                                        v-for="item in devices"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-repetitive-field>
            </el-form-item>

            <el-form-item label="Centros de Costo" label-width="120px" :error="scope.errors.cost_centers">
                <el-repetitive-field v-model="resource.cost_centers.value" :buttonText="'Centro de Costo'" :default="{cost_center_id:null,is_default:false,date_from:null,date_to:null}">
                    <template slot-scope="props">
                        <el-row>
                            <el-col :xs="18" :sm="10">
                                <el-form-item :prop="'cost_center_'+props.item.cost_center_id">
                                    <el-select v-model="props.item.cost_center_id" filterable placeholder="Seleccione" size="mini">
                                        <el-option
                                            v-for="item in cost_centers"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="5" :sm="3" :offset="1">
                                <el-form-item :prop="'cost_center_default_'+props.item.is_default">
                                    <el-checkbox v-model="props.item.is_default">Usar por defecto</el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :xs="24" :sm="12">
                                <el-form-item :prop="'cost_center_date_from_'+props.item.date_from">
                                    <el-date-picker v-model="props.item.date_from" 
                                    format="yyyy-MM-dd" :picker-options="{firstDayOfWeek:1}" placeholder="Desde"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <el-form-item :prop="'cost_center_date_to_'+props.item.date_to">
                                    <el-date-picker v-model="props.item.date_to" 
                                    format="yyyy-MM-dd" :picker-options="{firstDayOfWeek:1}" placeholder="Hasta"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </template>
                </el-repetitive-field>
            </el-form-item>

        </template>

        <template slot="moreMenu">
            <el-dropdown-item :command="handleSendUsersToDevices">Enviar empleados a dispositivos</el-dropdown-item>
            <el-dropdown-item :command="handleImportTemplatesFromDevices">Importar templates de dispositivos</el-dropdown-item>
        </template>

    </el-crud>

</div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { getOptionLabel } from '../../utils/lib';
    import el_crud from '../el-crud.vue';
    import el_repetitive_field from '../el-repetitive-field.vue';
    export default {
        data() {
            return {
                crudConfig:{
                    AddItemTitle: 'Nueva Área',
                    EditItemTitle: 'Editar Área',
                    DeleteItemConfirmMessage: 'Esto borrará permanentemente el área. Desea continuar?'
                },
                filters: {
                    shift_id: null,
                    device_id: null,
                    filter: null,
                },
                shiftsOptions: [],
                // devicesOptions: [],
                resource:{
                    description: null,
                    company_id_number: null,
                    feed:{
                        value: false,
                        setValue: (value) => {
                            // console.log('feed.setValue');
                            // console.log(value);
                            this.resource.feed.value = (value === true) ? true : false;
                            // console.log(this.resource.feed.value);
                        }
                    },
                    shifts:{
                        value: null,
                        setValue: (value) => {
                            this.resource.shifts.value = [];
                            // console.log(value);
                            if (value != null) {
                                _.each(value.shifts, (shift) => {
                                    this.resource.shifts.value.push({
                                        shift_id: shift.id.toString(),
                                        description: shift.pivot.description
                                    });
                                });
                            }
                        }
                    },
                    devices:{
                        value: null,
                        setValue: (value) => {
                            this.resource.devices.value = [];
                            // console.log(value);
                            if (value != null) {
                                _.each(value.devices, (device) => {
                                    this.resource.devices.value.push({
                                        device_id: device.id.toString(),
                                        description: device.pivot.name
                                    });
                                });
                            }
                        }
                    },
                    cost_centers:{
                        value: null,
                        setValue: (value) => {
                            this.resource.cost_centers.value = [];
                            // console.log(value);
                            if (value != null) {
                                _.each(value.cost_centers, (cost_center) => {
                                    this.resource.cost_centers.value.push({
                                        cost_center_id: cost_center.id.toString(),
                                        is_default: cost_center.pivot.is_default == 1,
                                        date_from: cost_center.pivot.date_from,
                                        date_to: cost_center.pivot.date_to,
                                    });
                                });
                            }
                        }
                    },
                },
            }
        },
        components: {
            'el-crud': el_crud,
            'el-repetitive-field': el_repetitive_field
        },
        computed: {
            ...mapGetters(["devices", "cost_centers"]),
            'shift_name': function () { return getOptionLabel(this.shiftsOptions, this.filters.shift_id) },
            'device_name': function () { return getOptionLabel(this.devices, this.filters.device_id) },
            'areFilters': function () {
                return (this.filters.shift_id != null && this.filters.shift_id.length > 0)
                        || (this.filters.device_id != null && this.filters.device_id.length > 0)
                        || this.filters.filter != null;
            }
        },
        mounted() {
            axios.get('/api/shifts/options').then((response) => {
                _.each(response.data, (description, id) => {
                    this.shiftsOptions.push({label: description, value: id})
                });
                this.shiftsOptions = _.sortBy(this.shiftsOptions, 'label');
            });
            this.fetchDevices();
            this.fetchCostCenters();
            // axios.get('/api/devices/options').then((response) => {
            //     _.each(response.data, (description, id) => {
            //         this.devicesOptions.push({label: description, value: id})
            //     });
            //     this.devicesOptions = _.sortBy(this.devicesOptions, 'label');
            // });
        },
        methods: {
            ...mapActions(["fetchDevices", "fetchCostCenters"]),
            handleSendUsersToDevices(row) {
                console.log('handleSendUsersToDevices ' + row.id);
                console.log(this.resource);
                // axios.post('/api/employees/sendEnrolledUsersToDevices', {functional_area_id: areaId}).then((response) => {});
            },
            handleImportTemplatesFromDevices(row) {
                console.log('handleImportTemplatesFromDevices ' + row.id);
                // axios.post('/api/employees/fetchusersfacetemplates', {functional_area_id: areaId}).then((response) => {});
            }
        }
    }
</script>
